export class CONSTANTS {
  public static DIPE_CODE_REGISTER = 'C04';
  public static DIPE_NUMBER = '00000';
  public static SPACE = ' ';
  public static CAPPED_CONTRIBUTE_SALARY = 750000;
  public static CNPS_REGIME = [
    { label: 'GENERAL', value: '1' },
    { label: 'AGRICOLE', value: '2' },
    { label: 'ENSEIGNEMENT PRIVE', value: '3' },
    { label: 'DOMESTIQUE', value: '4' },
  ];
}
export const CNPS_REGIME = new Map([
  ['1', 'général'],
  ['2', 'agricole'],
  ['3', 'enseignement privé'],
  ['4', 'domestique'],
]);
